import React from 'react';
import { WithTooltip } from '@riac/design-system';
import { Legend } from 'src/pages/CatalogPage/components/FilterMenu/IconLegend/IconLegend.styles';
import { LazyImg } from '@riac/design-system';

import LogoRare from 'images/logo-rare.png';
import LogoDocumentation from 'images/logo-documentation.png';
import LogoBox from 'images/logo-box.png';
import LogoAntique from 'images/logo-antique.png';
import LogoClass3 from 'images/logo-class3.png';
import LogoModern from 'images/logo-modern.png';
import LogoCR from 'images/logo-cr.png';
import LogoInterest1 from 'images/logo-rating-level1.png';
import LogoVideo from 'images/logo-youtube.png';

export const IconLegend = (): JSX.Element => {
  return (
    <Legend>
      <h5>Icon Legend</h5>
      <ul>
        {/* <li>
          <WithTooltip position='top' text='Lot contains multiple items' inverted>
            <LazyImg
              src={broken('images/icon-unreadsystem.jpg')}
              id='MultiItemLot'
              alt='Lot contains multiple items'
            />
            Multi-Item Lot
          </WithTooltip>
        </li>
        <li>
          <WithTooltip position='top' text='Lot contains rare items' inverted>
            <LazyImg
              src={LogoRare}
              id='ProfoundlyRareLegendItem'
              alt='Lot contains rare items'
            />
            Profoundly Rare
          </WithTooltip>
        </li> */}
        <li>
          <WithTooltip position='top' text='Lot contains items with documentation' inverted>
            <LazyImg
              src={LogoDocumentation}
              id='DocumentedLegendItem'
              alt='Lot contains items with documentation'
            />
            Documentation
          </WithTooltip>
        </li>
        <li>
          <WithTooltip position='top' text='Lot contains antique items' inverted>
            <LazyImg
              src={LogoAntique}
              id='DocumentedAntiqueItem'
              alt='Lot contains antique items'
            />
            Antique
          </WithTooltip>
        </li>
        <li>
          <WithTooltip position='top' text='Lot contains items with box' inverted>
            <LazyImg
              src={LogoBox}
              id='ItemWithBoxLot'
              alt='Lot contains items with box'
            />
            Has Box
          </WithTooltip>
        </li>
        <li>
          <WithTooltip position='top' text='Lot contains Class III items' inverted>
            <LazyImg
              src={LogoClass3}
              id='ClassIIILot'
              alt='Lot contains Class III items'
            />
            Class III
          </WithTooltip>
        </li>
        <li>
          <WithTooltip position='top' text='Lot contains Modern items' inverted>
            <LazyImg
              src={LogoModern}
              id='LegendModernItems'
              alt='Lot contains Modern items'
            />
            Modern Item
          </WithTooltip>
        </li>
        <li>
          <WithTooltip position='top' text='Lot contains Curio and Relic items' inverted>
            <LazyImg
              src={LogoCR}
              id='CurioAndRelicItem'
              alt='Lot contains Curio and Relic items'
            />
            Curio and Relic Item
          </WithTooltip>
        </li>
        <li>
          <WithTooltip position='top' text='Lot contains items with attached video' inverted>
            <LazyImg
              src={LogoVideo}
              id='AttachedVideoLegend'
              alt='Lot contains items with attached video'
            />
            Has Video
          </WithTooltip>
        </li>
        <li>
          <WithTooltip position='top' text='Indicates level of item interest' inverted>
            <LazyImg
              src={LogoInterest1}
              id='ItemInterestLegend'
              alt='Indicates level of item interest'
            />
            Level of Item Interest
          </WithTooltip>
        </li>
      </ul>
    </Legend>
  );
};
